/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from "react";
import { NON_RKPAY_INVOICE_COLUMNS } from "@constants";
import PropTypes from "prop-types";
import utils from "@utils";
import { ContactService } from "@services";
import { ScrollDetect } from "../../../../components";
import SendRemindersModal from "./SendRemindersModal";

const AwaitingPaymentTable = ({
	updateSort,
	selectAllRecords,
	multipleSelection,
	filters,
	records,
	onEditInvoice,
	selectedRecords,
	updateSelectedRecord,
	user,
	showMultipleOfficerModal,
	hasMoreRecords,
	loadNextPage
}) => {
	const { lang } = global;
	const [showSendRemindersModal, setShowSendRemindersModal] = React.useState(false);
	const [reminderData, setReminderData] = React.useState({ isLoading: false });
	const [contactData, setContactData] = useState({ isLoading: true });

	/** Retrieve a comprehensive list of contacts for the client (non-paginated) */
	const getContacts = () => {
		setContactData({ isLoading: true });

		ContactService.getAll({ clientId: reminderData.ClientId })
			.then(({ data }) => {
				setContactData({ isLoading: false, data });
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error loading client contacts"),
					timeOut: 1500,
				});
			});
	};

	useEffect(() => {
		if (reminderData.ClientId) {
			getContacts();
		}
	}, [reminderData]);

	return (
		<>
			<div className="row hidden-xs hidden-sm hidden-md invoice-columns">
				<div
					className="col-md-2 col-lg-2"
					role="button"
					tabIndex="0"
					onClick={() => updateSort(NON_RKPAY_INVOICE_COLUMNS.InvoiceNumber)}
					onKeyPress={({ key }) => {
						if (key === "Enter") updateSort(NON_RKPAY_INVOICE_COLUMNS.InvoiceNumber);
					}}
				>
					<If condition={multipleSelection}>
						<label
							htmlFor="checkbox_all"
							className="selector-label margin-right-12"
						>
							<input
								type="checkbox"
								id="checkbox_all"
								name="selectAllItems"
								onChange={() => selectAllRecords()}
								onClick={e => e.stopPropagation()}
								aria-label="Select All Items"
								disabled
							/>
						</label>
					</If>
					<span className="font-semi-bold">{lang.t("Invoice")} #</span>
					<If condition={filters.sortBy === NON_RKPAY_INVOICE_COLUMNS.InvoiceNumber}>
						<i
							className={`glyphicon glyphicon-triangle-${filters.asc ? "top" : "bottom"}`}
						/>
					</If>
				</div>
				<div
					className="col-md-2 col-lg-2"
					role="button"
					tabIndex="0"
					onClick={() => updateSort(NON_RKPAY_INVOICE_COLUMNS.ClientName)}
					onKeyPress={({ key }) => {
						if (key === "Enter") updateSort(NON_RKPAY_INVOICE_COLUMNS.ClientName);
					}}
				>
					<span className="font-semi-bold">{lang.t("Client")}</span>
					<If condition={filters.sortBy === NON_RKPAY_INVOICE_COLUMNS.ClientName}>
						<i
							className={`glyphicon glyphicon-triangle-${filters.asc ? "top" : "bottom"}`}
						/>
					</If>
				</div>
				<div className="col-md-2 col-lg-2">
					<span className="font-semi-bold">{lang.t("Officer")}</span>
					<If condition={filters.sortBy === NON_RKPAY_INVOICE_COLUMNS.Officer}>
						<i
							className={`glyphicon glyphicon-triangle-${filters.asc ? "top" : "bottom"}`}
						/>
					</If>
				</div>
				<div
					className="col-md-2 col-lg-1 date-range-column"
					role="button"
					tabIndex="0"
				>
					<span className="font-semi-bold">{lang.t("Job Date")}</span>
				</div>
				<div
					className="col-md-1 col-lg-1"
					role="button"
					tabIndex={0}
					onClick={() => updateSort(NON_RKPAY_INVOICE_COLUMNS.SentDate)}
					onKeyPress={({ key }) => {
						if (key === "Enter") updateSort(NON_RKPAY_INVOICE_COLUMNS.SentDate);
					}}
				>
					<span className="font-semi-bold">{lang.t("Sent Date")}</span>
					<If condition={filters.sortBy === NON_RKPAY_INVOICE_COLUMNS.SentDate}>
						<i
							className={`glyphicon glyphicon-triangle-${filters.asc ? "top" : "bottom"}`}
						/>
					</If>
				</div>
				<div
					className="col-md-1 col-lg-1"
					role="button"
					tabIndex={0}
					onClick={() => updateSort(NON_RKPAY_INVOICE_COLUMNS.DueDate)}
					onKeyPress={({ key }) => {
						if (key === "Enter") updateSort(NON_RKPAY_INVOICE_COLUMNS.DueDate);
					}}
				>
					<span className="font-semi-bold">{lang.t("Due Date")}</span>
					<If condition={filters.sortBy === NON_RKPAY_INVOICE_COLUMNS.DueDate}>
						<i
							className={`glyphicon glyphicon-triangle-${filters.asc ? "top" : "bottom"}`}
						/>
					</If>
				</div>
				<div
					className="col-md-2 col-lg-2 text-right"
					role="button"
					tabIndex={0}
					onClick={() => updateSort(NON_RKPAY_INVOICE_COLUMNS.Balance)}
					onKeyPress={({ key }) => {
						if (key === "Enter") updateSort(NON_RKPAY_INVOICE_COLUMNS.Balance);
					}}
				>
					<span className="font-semi-bold">{lang.t("Balance Due")}</span>
					<If condition={filters.sortBy === NON_RKPAY_INVOICE_COLUMNS.Balance}>
						<i
							className={`glyphicon glyphicon-triangle-${filters.asc ? "top" : "bottom"}`}
						/>
					</If>
				</div>
				<div className="col-md-1 col-lg-1 hidden-xs hidden-md" />
			</div>
			<div className="hidden-xs hidden-sm hidden-md invoice-columns-body">
				{records.length > 0 &&
					records.map(item => {
						const sameJobDay = utils.datesAreOnSameDay(
							new Date(item.StartDateTime),
							new Date(item.EndDateTime),
						);
						return (
							<div
								key={`${item.Id}-${item.InvoiceNumber}`}
								className="row"
								role="button"
								onClick={onEditInvoice(item.Id)}
								tabIndex={0}
							>
								<div className="col-md-2 col-lg-2 truncate">
									<If condition={multipleSelection}>
										<label
											htmlFor={`check_${item.Id}`}
											className="selector-label margin-right-12"
										>
											<input
												type="checkbox"
												id={`check_${item.Id}`}
												name="selectItem"
												checked={selectedRecords[item.Id]}
												onChange={() => updateSelectedRecord(item)}
												onClick={e => e.stopPropagation()}
												aria-label="Select Item"
												disabled
											/>
										</label>
									</If>
									<span>{item.InvoiceNumber}</span>
								</div>
								<div
									className="col-md-2 col-lg-2 truncate"
									title={item.ClientName}
								>
									<span>{item.ClientName}</span>
								</div>
								<div
									className="col-md-2 col-lg-2 truncate"
									title={
										item.OfficerNames.length > 1
											? lang.t("Multiple Officers")
											: item.OfficerNames[0]
									}
								>
									<If condition={item.OfficerNames.length > 1}>
										<button
											id={`multiple-officer-button-${item.Id}`}
											type="button"
											className="btn btn-link btn-officers"
											onClick={event => {
												event?.stopPropagation();
												showMultipleOfficerModal(item.Id);
											}}
										>
											{lang.t("Multiple Officers")}
										</button>
									</If>
									<If condition={item.OfficerNames.length <= 1}>
										<span>{item.OfficerNames[0]}</span>
									</If>
								</div>
								<div className="col-md-2 col-lg-1 date-range-column">
									<span>
										{sameJobDay
											? utils.formatDate(
													item.StartDateTime,
													"en-US",
													user.TimeZoneId,
													"numeric",
												)
											: `${utils.formatDate(item.StartDateTime, "en-US", user.TimeZoneId, "numeric")} - ${utils.formatDate(item.EndDateTime, "en-US", user.TimeZoneId, "numeric")}`}
									</span>
								</div>
								<div className="col-md-1 col-lg-1">
									<span>
										{item.SentDate == null
											? ""
											: utils.formatDate(
													item.SentDate,
													"en-US",
													user.TimeZoneId,
													"numeric",
												)}
									</span>
								</div>
								<div className="col-md-1 col-lg-1">
									<span>
										{utils.formatDate(
											item.DueDate,
											"en-US",
											user.TimeZoneId,
											"numeric",
										)}
									</span>
								</div>
								<div className="col-md-2 col-lg-2 text-right prepay-column">
									<div className="prepay-badge-container">
										<If condition={item.IsPrepaid}>
											<div
												className="prepay-badge"
												title={lang.t("Prepay")}
											/>
										</If>
									</div>
									<span className="font-semi-bold">
										{utils.currencyFormatter(utils.bankersRound(item.Balance))}
									</span>
								</div>
								<div className="col-md-12 col-lg-1 actions-column">
									<If condition={item.IsPrepaid}>
										<div
											className="prepay-badge hidden-md hidden-lg hidden-xl"
											title={lang.t("Prepay")}
										/>
									</If>
									{item.Voided ? (
										<button
											type="button"
											className="btn btn-primary btn-block grow"
											onClick={() => onEditInvoice(item.Id)}
											data-prevent-navigation
										>
											{lang.t("View")}
										</button>
									):(
										<button
											onClick={e => {
												e.stopPropagation();
												setReminderData(item);
												setShowSendRemindersModal(true);
											}}
											type="button"
											className="btn btn-primary grow"
										>
											{lang.t("Remind")}
										</button>
									)}
								</div>
							</div>
						);
					})}
			</div>

			<div className="hidden-lg">
				{records.length > 0 &&
					records.map(item => {
						const sameJobDay = utils.datesAreOnSameDay(
							new Date(item.StartDateTime),
							new Date(item.EndDateTime),
						);
						return (
							<div key={`${item.Id}-${item.InvoiceNumber}`} className="row">
								<div className="invoice-card">
									<div className="card-item">
										<If condition={item.IsPrepaid}>
											<div
												className="prepay-badge"
												title={lang.t("Prepay")}
											/>
										</If>
									</div>
									<div className="card-item">
										<span className="font-semi-bold">
											{lang.t("Invoice")} #:&nbsp;
										</span>
										<button
											className="btn btn-link"
											type="button"
											onClick={onEditInvoice(item.Id)}
										>
											{item.InvoiceNumber}
										</button>
									</div>
									<div className="card-item">
										<span className="font-semi-bold">
											{lang.t("Client")}:&nbsp;
										</span>
										<span>{item.ClientName}</span>
									</div>
									<div className="card-item">
										<span className="font-semi-bold">
											{lang.t("Officer")}:&nbsp;
										</span>
										<If condition={item.OfficerNames.length > 1}>
											<button
												type="button"
												className="btn btn-link btn-officers"
												onClick={() => showMultipleOfficerModal(item.Id)}
											>
												{lang.t("Multiple Officers")}
											</button>
										</If>
										<If condition={item.OfficerNames.length <= 1}>
											<span>{item.OfficerNames[0]}</span>
										</If>
									</div>
									<div className="card-item">
										<span className="font-semi-bold">
											{lang.t("Job Date")}:&nbsp;
										</span>
										<span>
											{sameJobDay
												? utils.formatDate(
														item.StartDateTime,
														"en-US",
														user.TimeZoneId,
														"numeric",
													)
												: `${utils.formatDate(item.StartDateTime, "en-US", user.TimeZoneId, "numeric")} - ${utils.formatDate(item.EndDateTime, "en-US", user.TimeZoneId, "numeric")}`}
										</span>
									</div>
									<div className="card-item">
										<span className="font-semi-bold">
											{lang.t("Sent Date")}:&nbsp;
										</span>
										<span>
											{item.SentDate == null
												? ""
												: utils.formatDate(
														item.SentDate,
														"en-US",
														user.TimeZoneId,
														"numeric",
													)}
										</span>
									</div>
									<div className="card-item">
										<span className="font-semi-bold">
											{lang.t("Due Date")}:&nbsp;
										</span>
										<span>
											{utils.formatDate(
												item.DueDate,
												"en-US",
												user.TimeZoneId,
												"numeric",
											)}
										</span>
									</div>
									<div className="card-item">
										<span className="font-semi-bold">
											{lang.t("Balance Due")}:&nbsp;
										</span>
										<span>
											{utils.currencyFormatter(
												utils.bankersRound(item.Balance),
											)}
										</span>
									</div>
									<div className="actions">
										<button
											onClick={e => {
												e.preventDefault();
												setReminderData(item);
												setShowSendRemindersModal(true);
											}}
											type="button"
											className="btn btn-primary grow"
										>
											{lang.t("Remind")}
										</button>
									</div>
								</div>
							</div>
						);
					})}
			</div>
			<If condition={hasMoreRecords}>
				<ScrollDetect
					className="text-center"
					onVisible={() => loadNextPage()}
				>
					<i className="glyphicon glyphicon-repeat rkf-spin rkf-fw" />
				</ScrollDetect>
			</If>
			<SendRemindersModal
				show={showSendRemindersModal}
				onCancel={() => setShowSendRemindersModal(false)}
				contactData={contactData?.data}
				clientId={reminderData?.ClientId}
				invoiceNumber={reminderData?.InvoiceNumber}
				invoiceId={reminderData?.Id}
				user={user}
				getContacts={getContacts}
			/>
		</>
	);
};

AwaitingPaymentTable.propTypes = {
	updateSort: PropTypes.func,
	selectAllRecords: PropTypes.func,
	multipleSelection: PropTypes.bool,
	filters: PropTypes.object,
	records: PropTypes.array,
	onEditInvoice: PropTypes.func,
	selectedRecords: PropTypes.object,
	updateSelectedRecord: PropTypes.func,
	user: PropTypes.object,
	showMultipleOfficerModal: PropTypes.func,
	loadNextPage: PropTypes.func,
	hasMoreRecords: PropTypes.bool
};

export default AwaitingPaymentTable;
